import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Team from './components/Team';
import Contact from './components/Contact';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfService from './components/legal/TermsOfService';
import { useKeyboardNavigation } from './hooks/useKeyboardNavigation';
import FloatingScheduleButton from './components/FloatingScheduleButton';
import SEO from './components/SEO';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  useKeyboardNavigation();

  return (
    <HelmetProvider>
      <div className="min-h-screen bg-white" role="document">
        <div 
          className="sr-only focus:not-sr-only focus:fixed focus:z-50 focus:p-4 focus:bg-white focus:border-2 focus:border-primary-600"
          tabIndex={0}
        >
          <h2 className="text-lg font-semibold mb-2">Keyboard Navigation</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Alt + ↑/k: Navigate to previous section</li>
            <li>Alt + ↓/j: Navigate to next section</li>
            <li>Alt + Home/1: Go to top</li>
            <li>Alt + End/5: Go to contact</li>
            <li>Tab: Move between interactive elements</li>
            <li>Enter/Space: Activate focused element</li>
          </ul>
        </div>

        <a 
          href="#main-content" 
          className="sr-only focus:not-sr-only focus:fixed focus:z-50 focus:p-4 focus:bg-white focus:border-2 focus:border-primary-600"
        >
          Skip to main content
        </a>

        <FloatingScheduleButton />
        <Header role="banner" />
        <main id="main-content" role="main">
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <About />
                <Services />
                <Team />
                <Contact />
              </>
            } />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer role="contentinfo" />
        <SEO />
      </div>
    </HelmetProvider>
  );
}

export default App;